import { DASHBOARD_URL, getBusinessSuccessPageURL } from 'src/dataLayer/env'
import { validateIdentityProviderAndRedirect } from 'src/dataLayer/remoteData/babbelAPI/validateIdentityProviderAndRedirect'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import useAsyncData from 'src/viewLayer/components/hooks/useAsyncData'

export default function useB2BSessionRequest(identityProvider) {
  const { environment, locale } = useRouteParamsContext()
  const isNativeMobileView = useAppConfigContext().devicePath === 'login-mobile'
  const SSOReturnToUrl = isNativeMobileView
    ? getBusinessSuccessPageURL(locale, environment)
    : DASHBOARD_URL

  const { data, inProgress, makeRequest } = useAsyncData(() =>
    validateIdentityProviderAndRedirect(identityProvider, locale, SSOReturnToUrl),
  )

  return {
    identityProviderValidationRequestInProgress: inProgress,
    isRedirecting: data?.isRedirecting,
    makeIdentityProviderValidationRequest: makeRequest,
  }
}
